export default __webpack_public_path__ + "static/media/roboto-v20-latin-500italic.07d7b0bb.ttf";